const RegEx = /\${[a-zA-Z0-9.$]+}/g

/**
 * This preprocess assumes that a `target` exists in the scope. It will
 * replace any '${xxx}' with 'target.xxx'.  If you really want the ${xxx} to
 * remain, double escape the '$'. eg "Hello \\${value}" will result in "Hello ${value}" 
 * @param {string} expression The expression to parse
 * @returns The new expression
 */
function process( expression ) {
  let exp = expression
  const matches = [ ...expression.matchAll( RegEx ) ]
  for ( let n = matches.length - 1; n >= 0; n-- ) {
    const m = matches[n]
    const idx = m.index
    if ( exp[idx - 1] === '\\' ) {
      exp = exp.substring( 0, idx - 1 ) + exp.substring( idx )
      continue
    }
    const len = m[0].length
    const fnc = `target.${m[0].substring( 2, len - 1 )}`
    exp = exp.substring( 0, idx ) + fnc + exp.substring( idx + len )
  }
  return exp
}

export default process
